import { MaintenanceWrapper } from './Maintenance.styles';

export const Maintenance = () => {
  return (
    <MaintenanceWrapper>
      <div className='col'>
        <div className='row d-flex wrapper'>
          <div className='col-md-6 padded-wrapper logo-wrapper align-self-center'>
            <img src='/DraxPowerBlue.svg' alt='Drax logo' className='drax-logo' />
          </div>
          <div className='col-md-6 padded-wrapper form-wrapper align-self-center'>
            <div className='row justify-content-center'>
              <img src='/HammerIcon.svg' alt='Hammer Icon' className='hammer-icon' />
            </div>

            <div className='row justify-content-center'>
              <div className='col-md-12'>
                <h1>Sorry! We'll be right back...</h1>
              </div>
            </div>

            <div className='row justify-content-center'>
              <p>We're sorry for the inconvenience, but our site is currently undergoing scheduled maintenance.</p>
            </div>

            <div className='row justify-content-center'>
              <p>
                If you need immediate assistance, please <a href='https://energy.drax.com/contact-us/'>contact us</a>.
                <br />
                Thanks for your patience!
              </p>
            </div>
          </div>
        </div>
      </div>
    </MaintenanceWrapper>
  );
};

export default Maintenance;
